import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const postContactsToHashtags = async (hashtagIds, contactIds) => {
  const apiURL = API_HOST + '/contact_hashtags_connections';
  const { token, userID } = useCurrentUser();
  
  try {
    const { data } = await axios.post(apiURL,{
      contact_hashtags_connections:{
          contact_hashtag_ids: hashtagIds,
          contact_ids: contactIds,
        }
    },{
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+token,
        'x-sb-user-id': userID
      }
    });
    return data.data;
  } catch (error) {
    console.error(error);
  }
};
